export default {
  Home: 'Home',
  login: 'Login',
  Dashboard: 'Dashboard',
  // 完工管理系统
  // router
  Import: 'Imports',
  Import_Logs: 'Import Logs',
  RefTable: 'RefTable',
  Activity: 'Activity',

  AuthorisedPerson: 'Authorised Person',
  Disciplines: 'Disciplines',
  System: 'System',
  SystemDescription: 'System Description',
  Profession: 'Profession',
  SubSystem: 'Sub System',
  SystemGroup: 'System Group',
  ITRs: 'ITRs',
  MOCs: 'MOCs',
  Document: 'Document',
  menumanagement: 'Menu Management',
  Accountlist: 'Account List',
  // 发行一版之后添加的
  Drawing: 'Drawing',
  DrawingType: 'Drawing Type',
  DrawingStatus: 'Drawing Status',
  TagITRs: 'Tag ITR',
  Certification: 'Certification',
  EquipmentType: 'Equipment Type',
  EquipmentStatus: 'Equipment Status',
  EquipmentTypeITR: 'Equipment Type to ITR',
  EquipmentTypePWL: 'Equipment Type to PWL',
  TagITRCompletionStatus: 'Tag ITR Completion Status',
  Handover: 'Handover',
  CCC: 'CCC',
  MCC: 'MCC',
  PAC: 'PAC',
  RFSU: 'RFSU',
  FAC: 'FAC',
  Phase: 'Phase',
  Cable: 'Cable',
  CableType: 'Cable Type',
  DigitalDocumentCheckBoxType: 'Digital Document Check Box Type',
  WorkPack: 'Work Packs',
  JobCard: 'Job Card',
  Operation: 'Operation',
  WorkPackGrid: 'Work Pack Grid',
  WorkPackSkyline: 'Work Pack Skyline',
  JobCardSkyline: 'Job Card Skyline',
  JobCardPlannedvsActualProgress: 'Job Card Planned vs Actual Progress',
  ExCertifyingbody: 'Ex Certifying Body',
  ExIPRating: 'Ex IP Rating',
  ExProtection: 'Ex Protection',
  ExRatedModels: 'Ex Rated Models',
  ExRatedtoITR: 'Ex Rated to ITR',
  ExZones: 'Ex Zones',
  GlandTypes: 'Gland Types',
  HandoverCompletionStatus: 'Handover Completion Status',
  JobCardStatus: 'Job Card Status',
  Location: 'Location',
  Loop: 'Loop',
  LoopElement: 'Loop Element',
  MOCStatus: 'MOC Status',
  MOCType: 'MOC Type',
  Module: 'Module',
  NotificationGroup: 'Notification Group',
  NotificationGroupAuthorisedPerson: 'Notification Group Authorised Person',
  OperationType: 'Operation Type',
  ParentTag: 'Parent Tags',
  PreservationCompletionStatus: 'Preservation Completion Status',
  ProcedureCategory: 'Procedure Category',
  ProcedureClass: 'Procedure Class',
  ProcedureCompletionStatus: 'Procedure Completion Status',
  ProcedureDocumentStatus: 'Procedure Document Status',
  PunchListItemCategory: 'Punch List Item Category',
  PWL: 'PWL',
  ServiceDetail: 'Service Detail',
  ServiceInterval: 'Service Interval',
  Skill: 'Skill',
  TestPackType: 'Test Pack Type',
  UnitsofMeasure: 'Units of Measure',
  Vendor: 'Vendor',
  WorkGroup: 'Work Group',
  WorkPackCompletionStatus: 'Work Pack Completion Status',
  WorkPackType: 'Work Pack Type',
  TaggedItems: 'Tagged Items',
  All: 'All',
  Line: 'Line',
  MechanicalJoint: 'Mechanical Joint',
  Spool: 'Spool',
  Tag: 'Tag',
  TestPack: 'Test Pack',
  TagSet: 'Tag Set',
  MultiTagITR: 'Multi Tag ITR',
  EquipmentTypetoITRReview: 'Equipment Type to ITR Review',
  TagReviewforExAllocation: 'Tag Review for Ex Allocation',
  CompletionsGrid: 'Completions Grid',
  PunchList: 'Punch List',
  PunchListItem: 'Punch List Item',
  Procedure: 'Procedure',
  ProcedureSection: 'Procedure Section',
  ProcedureStep: 'Procedure Step',
  ProcedureSkeleton: 'Procedure Skeleton',
  ProcedureSkeletonSection: 'Procedure Skeleton Section',
  ProcedureSkeletonStep: 'Procedure Skeleton Step',
  Preservation: 'Preservation',
  TagPWL: 'Tag PWL',
  LookAhead: 'Look Ahead',
  EquipmentTypetoPWLReview: 'Equipment Type to PWL Review',
  AsBuiltDrawing: 'As Built Drawing',
  Attachment: 'Attachment',
  ProcedureType: 'Procedure Type',
  // page
  SEARCH: 'SEARCH',
  Recent: 'Recent Searches',
  SavedSearches: 'Saved Searches',
  PRECISIONSEARCH: 'PRECISION SEARCH',
  ADVANCEDSEARCH: 'ADVANCED SEARCH',
  ADDButton: 'ADD',
  DeleteButton: 'Delete',
  ExportButton: 'Export',
  Name: 'Name',
  Description: 'Description',
  DocType: 'Doc Type',
  AddTitle: 'ADD',
  EditTitle: 'Edit',
  Search: 'Search',
  SaveSearch: 'Save Search',
  Clear: 'Clear',
  Discipline: 'Discipline',
  ITRClass: 'ITR Class',
  ITRClassDescription: 'ITR Class Description',
  Manhours: 'Manhours',
  GenerationMethod: 'Generation Method',
  DigitalDocument: 'Digital Document',
  DOTXTemplate: 'DOTX Template',
  Revision: 'Revision',
  IsMultiTag: 'Is Multi Tag',
  IsMockITR: 'Is Mock ITR',
  WitnessPoints: 'Witness Points',
  HoldPoints: 'Hold Points',
  CreatedDate: 'Created Date',
  UpdatedDate: 'Updated Date',
  ChangeHistory: 'Change History',
  ShowDates: 'Show Dates',
  Area: 'Area',

  SubcontractorName: 'Subcontractor Name',
  Company: 'Company',
  Comments: 'Comments',
  ProfessionDiscipline: 'Profession Discipline',
  HandoverGate: 'Handover Gate',
  // 发行一版之后添加的
  RevisionDate: 'Revision Date',
  Region: 'Area',
  Moudle: 'Moudle',
  Sheet: 'Sheet',
  Originator: 'Originator',
  DrawingTypeDescription: 'Drawing Type Description',
  Link: 'Link',
  Subsystem: 'Subsystem',
  Priority: 'Priority',
  Attachments: 'Attachments',
  TestReference: 'Test Reference',
  ITRDiscipline: 'ITR Discipline',
  IsDefault: 'Is Default',
  RequiresReason: 'Requires Reason',
  DefaultFrequency: 'Default Frequency',
  PWLDiscipline: 'PWL Discipline',
  Changes: 'Changes',
  Download: 'Download',
  Report: 'Report',
  ReportList: 'Report List',
  PlannedVsActualProgress: 'Planned Vs Actual Progress',
  Skyline: 'Skyline',
  ScheduledReport: 'Scheduled Report',
  Admin: 'Admin',
  SystemSettings: 'System Settings',
  User: 'User Management',
  Menu: 'Menu Management',
  Role: 'Role Management',
  Department: 'Department Management',
  PostManagement: 'Post Management',
  LevelSelect: 'Level Select',
  LevelA: 'Level A',
  LevelB: 'Level B',
  LevelC: 'Level C',
  LevelD: 'Level D',
  LevelE: 'Level E',
  // 按钮
  History: 'History',
  Save: 'Save',

  SaveView: 'Save & View',
  Submit: 'Save',
  // 发行一版之后添加的
  Cancel: 'Cancel',
  // 9 - 9 li 新增
  RaisedBy: 'Raised By',
  RaisedDate: 'Raised Date',
  DocumentReference: 'Document Reference',
  ParentMOC: 'Parent MOC',
  Taggeditems: 'Tagged Items',
  PrimaryHandover: 'Primary Handover',
  SecondaryHandover: 'Secondary Handover',
  DetailedDescription: 'Detailed Description',
  Response: 'Response',
  ProposedSolution: 'Proposed Solution',
  RequiresClarifcation: 'Requires Clarifcation',
  EngineeringComplete: 'Engineering Complete',
  PACToBelssued: 'PAC To Be lssued',
  NCRToBelssued: 'NCR To Be lssued',
  OriginatorAcceptsProposal: 'Originator Accepts Proposal',
  Accepted: 'Accepted',
  NotAnswered: 'Not Answered',
  Rejected: 'Rejected',
  lmpactNo: 'lmpact No',
  ActionsTaken: 'Actions Taken',
  ClosedDate: 'Closed Date',

  ProposedAction: 'Proposed Action',
  // 数字文档
  PreviewTips: 'Preview is for demonstration purposes only.For an accurate representation, please generate the PDF.',
  SaveRevision: 'Save Revision',
  SaveasNewRevision: 'Save as New Revision',
  Clonefrom: 'Clone from...',
  RemoverowButton: 'Remove',
  AddcolumnButton: 'Add Column',
  ADDROWButton: 'ADD ROW',
  ADDNewTable: 'Add New Table',
  AddNewTask: 'Add New Task',
  NoComment: 'No Comment',
  InlineComment: 'Inline Comment',
  LongCommnet: 'Long Commnet',
  Checkbox: 'Checkbox',
  Signature: 'Signature',
  CheckboxSignature: 'Checkbox Signature',
  Date: 'Date',
  DateCheckbox: 'Date Checkbox',
  DateSignature: 'Date Signature',
  DateCheckboxSignature: 'Date Checkbox Signature',
  Table: 'Table',
  Image: 'Image',
  None: 'None',
  MultipleChoice: 'Multiple Choice',
  Addtitle: 'Add Title',
  Required: 'Required',
  weighting: 'weighting',
  AddNewSignoff: 'Add New Sign Off',
  Complete: 'Complete',
  Orientation: 'Orientation',
  Portrait: 'Portrait',
  Landscape: 'Landscape',
  HideComments: 'Hide Comments',
  Optional: 'Optional',
  CheckboxOptions: 'Checkbox Options',
  PreviewDocument: 'Preview Document',
  DownloadTemplate: 'Download Template',
  CreateDocument: 'Create Document',
  // 9 - 20
  HubUser: 'User',
  Position: 'Position',
  Inactive: 'Inactive',
  SignOffProcedures: 'Sign Off Procedures',
  SectionPermissions: 'Section Permissions',
  SignOffWorkPacks: 'Sign Off Work Packs',
  SignOffOperations: 'Sign Off Operations',
  SignOffTagITRs: 'Sign Off Tag ITRs',
  SignOffPreservations: 'Sign Off Preservations',
  SignOffWorkPackApprovals: 'Sign Off Work Pack',
  ReviewAsBuiltDrawings: 'Review AsBuilt Drawings',
  SignOffPunchListItems: 'Sign Off Punch List Items',
  SignOffTestPacks: 'Sign Off Test Packs',
  SignOffJobCards: 'Sign Off Job Cards',
  AcceptAsBuiltDrawings: 'Accept As Built Drawings',
  SignOffMOC: 'Sign Off MOC',
  SignOffHandovers: 'Sign Off Certificate',
  SignOffAssuranceTrackers: 'Sign Off Assurance Trackers',
  Professions: 'Professions',
  // 9 - 23
  From: 'From',
  To: 'To',
  SourceDrawing: 'Source Drawing',
  SerialNumber: 'Serial Number',
  Manufacturer: 'Manufacturer',
  ModelNumber: 'Model Number',
  PurchaseOrderNumber: 'Purchase Order Number',
  DataSheetNumber: 'Data Sheet Number',
  FromGlandType: 'From Gland Type',
  ToGlandType: 'To Gland Type',
  Voltage: 'Voltage',
  PulledLength: 'Pulled Length',
  IsValidated: 'Is Validated',
  IsSafetyCriticalElement: 'Is Safety Critical Element',
  IgnoreEquipmentTypeToITR: 'Ignore Equipment Type To ITR',
  IgnoreEquipmentTypeToPWL: 'Ignore Equipment Type To PWL',
  // 9 - 24
  Approved: 'Approved',
  LocksWorkPack: 'Locks Work Pack',
  Yes: 'Yes',
  No: 'No',
  // 10 - 09
  DocumentCode: 'Document Code',
  JobCardDrawing: 'Job Card Drawing',
  PercentComplete: 'Percent Complete',
  HideAdditionalFilters: 'Hide Additional Filters',
  ShowAdditionalFilters: 'Show Additional Filters',
  ActualStartDate: 'Actual Start Date',
  ActualFinishDate: 'Actual Finish Date',
  PlannedStartDate: 'Planned Start Date',
  PlannedFinishDate: 'Planned Finish Date',
  CurrentEstimate: 'Current Estimate',
  OriginalEstimate: 'Original Estimate',
  RejectionReason: 'Rejection Reason',
  SignedOffBy: 'Signed Off By',
  SignedOffDate: 'Signed Off Date',
  SignedOff: 'Signed Off',
  NotSignedOff: 'Not Signed Off',
  AcceptedBy: 'Accepted By',
  AcceptedDate: 'Accepted Date',
  NotAccepted: 'Not Accepted',
  AssignedDate: 'Assigned Date',
  AssignedTo: 'Assigned To',
  Order: 'Order',
  SubSystemPhase: 'Sub System Phase',
  SubSystemPriority: 'Sub System Priority',
  WorkPackAssignedTo: 'Work Pack Assigned To',
  WorkPackOriginator: 'Work Pack Originator',
  WorkPackSignedOffBy: 'Work Pack Signed Off By',
  WorkPackTypeCoverSheetHandoverType: 'Work Pack Type Cover Sheet Handover Type',
  // 10 - 10
  ITRClassHandoverGate: 'ITR Class Handover Gate',
  ITRGenerationMethod: 'ITR Generation Method',
  IsMultiTagITR: 'Is Multi Tag ITR',
  ITRWitnessPoints: 'ITR Witness Points',
  TaggedItemTagType: 'Tagged Item Tag Type',
  JobCardActivity: 'Job Card Activity',
  JobCardWorkPack: 'Job Card Work Pack',
  ScheduleRevision: 'Schedule Revision',
  ScheduleGroup: 'Schedule Group',
  IssuedAsPaper: 'Issued As Paper / PDF Version',
  Any: 'Any',
  TaggedItem: 'Tagged Item',
  TaggedItemSubcontractorName: 'Tagged Item Subcontractor Name',
  SourceDrawingType: 'Source Drawing Type',
  TaggedItemComments: 'Tagged Item Comments',

  IsExRated: 'Is Ex Rated',
  SignOffs: 'Sign Offs',
  CompletedBy: 'Completed By',
  CompletedDate: 'Completed Date',
  Completed: 'Completed',
  NotCompleted: 'Not Completed',
  IssuedBy: 'Issued By',
  IssuedDate: 'Issued Date',
  Issued: 'Issued',
  NotIssued: 'Not Issued',
  // 10 - 11
  Year: 'dd/mm/yy',
  SearchPunchListItem: 'Search Punch List Items',
  TagITRAttachments: 'Tag ITR Attachments',
  TagAttachments: 'Tag Attachments',
  Editdigitaldocuments: 'Edit Digital Documents',
  // 10 - 12
  PWLDocument: 'PWL Document',

  EditDocument: 'Edit Document',
  Label: 'Label',
  SignOffType: 'Sign Off Type',
  Handovers: 'Handovers prevented if this Punch List Item Category is outstanding',
  Grouping: 'Grouping',
  InUse: 'In Use',
  PLICategoryDocument: 'PLI Category Document',
  GetBookmarkList: 'Get Bookmark List',
  GroupName: 'GroupName',
  RoleDescription: 'Role Description',
  GroupDescription: 'Group Description',
  AssignUser: 'Assign User',
  More: 'More',
  GeneratePDF: 'Generate as PDF',
  Reject: 'Reject',
  AddImageButton: 'Add Image',
  signOff: 'Sign Off',
  Confirm: 'Confirm',
  Assign: 'Assign',
  RemoveTableButton: 'Remove Table',
  AddColumns: 'Add Columns',
  tableLabel: 'table Label',
  TableBookmark: 'Table Bookmark',
  ColumnsOrderBy: 'Columns Order By',
  AddMultipleTasks: 'Add Multiple Tasks',
  RemoveTitle: 'Remove Title',
  ConfigureTable: 'Configure Table',
  AddNewRow: 'Add New Row',
  CopyRow: 'Copy Row',
  AddCell: 'Add Cell',
  AddEmptyRow: 'Add Empty Row',
  InterimAcceptedDate: 'Interim Accepted Date',
  InterimAccepted: 'Interim Accepted',
  NotInterimAccepted: 'Not Interim Accepted',
  InterimAcceptedBy: 'Interim Accepted By',

  Verified: 'Verified',
  VerifiedDate: 'Verified Date',
  ApprovedBy: 'Approved By',
  ApprovedDate: 'Approved Date',
  NotVerified: 'Not Verified',
  PlannedFinish: 'Planned Finish',
  Reviewed: 'Reviewed',
  NotReviewed: 'Not Reviewed',
  SigendOffDate: 'Sigend Off Date',
  CertificationGrouping: 'Certification Grouping',
  PartialHandovers: 'Partial Handovers',
  AddPartialHandovers: 'Add Partial Handovers',
  Add: 'Add',
  ReviewedBy: 'Reviewed By',
  VerifiedBy: 'Verified By',
  ReviewedDate: 'Reviewed Date',
  Workshop: 'Workshop',
  DocumentGenerate: 'Document Generate',
  FullHandoverDocument: 'Full Handover Documentation',
  GenerateHandoverDossier: 'Generate Handover Dossier',
  SelectAll: 'Select All',
  WalkDowns: 'Walk Downs',
  RaiseMCCs: 'Raise MCCs',
  RaiseDeleteMCCs: 'Raise/Delete MCCs',
  RaiseSelected: 'Raise Selected',
  RaiseSelectedAsMultiHandover: 'Raise Selected As Multi Handover',
  RaiseAllFromSearch: 'Raise All From Search',
  Raise: 'Raise',
  TotalCount: 'Total Count',
  TotalCompleted: 'Total Completed',
  TotalOutstanding: 'Total Outstanding',
  Size: 'Size',
  Source: 'Source',
  UploadNew: 'Upload New',
  SelectDocumentumFile: 'Select Documentum File',
  Added: 'Added',
  Deleteted: 'Deleteted',
  Updated: 'Updated',
  Invalid: 'Invalid',
  Unchanged: 'Unchanged',
  Viewresults: 'View results',
  PleaseselectanImportExportTable: 'Please Select A Table',
  Pleaseselect: 'Please select',
  ImportTitle: 'Import',
  PleaseselectaFileToImport: 'Please select a File To Import',
  SelectFile: 'Select File',
  PleaseselectTypeofImport: 'Please select Type of Import',
  Validater: 'Validate',
  Simulate: 'Simulate',
  Full: 'Full',
  ExportTitle: 'Export',
  DownloadBlankTemplate: 'Download Blank Template',
  SelectFormat: 'Select Format',
  DownloadAllBlankTemplate: 'Download All Blank Template',
  ExportOptions: 'Export Options',
  pleasechoosetheformatfordownload: 'Please choose the format for download',
  OK: 'OK',
  FileName: 'File Name',

  Deleted: 'Deleted',
  ImportSetting: 'Import Setting',
  ImportResult: 'Import Result',
  DownloadResultFile: 'Download Result File',
  Users: 'Users',
  RecordsProcessed: 'Records Processed',
  TotalAdded: 'Total Added',
  TotalDeleted: 'Total Deleted',
  TotalUpdated: 'Total Updated',
  TotalInvalid: 'Total Invalid',
  TotalNotProcessed: 'Total Not Processed',
  TotalUnchanged: 'Total Unchanged',
  ToBeAdded: 'To Be Added',
  ToBeDeleted: 'To Be Deleted',
  ToBeUpdated: 'To Be Updated',
  StoredAsJson: 'Stored As Json',
  ImportTable: 'Import Table',
  AttachmentsPendingUpload: 'Attachments Pending Upload',
  UploadAll: 'Upload All',
  AttachedTo: 'Attached To',
  DocumentType: 'Document Type',
  UseDocumentCode: 'Use Document Code',
  FileStatus: 'File Status',
  Defaultsginoffs: 'Default Sign Offs',
  Type: 'Type',
  RemoveSignOff: 'Remove Sign Off',
  EditTagITR: 'Edit Tag ITR',
  EditPunchListItem: 'Edit Punch List Item',
  EditTagPWL: 'Edit Tag PWL',
  EditWorkPack: 'Edit Work Pack',
  MOC: 'MOC',
  EditMOC: 'Edit MOC',
  AssuranceTracker: 'Assurance Tracker',
  EditAssuranceTracker: 'Edit Assurance Tracker',
  Require: 'Require',
  TotalAccepted: 'Total Accepted',
  IsOWLTask: 'Is OWL Task',

  // 12-23
  PlannedDate: 'Planned Date',
  ClearedBy: 'Cleared By',
  ClearedDate: 'Cleared Date',
  NotCleared: 'Not Cleared',
  AddDOTXTemplate: 'Add DOTX Template',

  SelectOptions: 'Select Options',

  Pleasechoose: 'Please choose the columns for export',
  Cores: 'Cores',
  IgnoreEquipment: 'Ignore Equipment',
  DrawingTypeName: 'Drawing Type Name',

  DocumentType: 'Document Type',
  UseDocumentCode: 'Use Document Code',
  FileStatus: 'File Status',
  Defaultsginoffs: 'Default Sign Offs',
  Type: 'Type',
  RemoveSignOff: 'Remove Sign Off',
  EditTagITR: 'Edit Tag ITR',
  EditPunchListItem: 'Edit Punch List Item',
  EditTagPWL: 'Edit Tag PWL',
  EditWorkPack: 'Edit Work Pack',
  MOC: 'MOC',
  EditMOC: 'Edit MOC',
  AssuranceTracker: 'Assurance Tracker',
  EditAssuranceTracker: 'Edit Assurance Tracker',
  Require: 'Require',

  HandoverByEntity: 'Handover By Entity',
  Gates: 'Gates',
  InterimDates: 'Interim Dates',
  PartialHandover: 'Partial Handover',
  MultiHandover: 'Multi Handover',
  TrackWalkdowns: 'Track Walkdowns',
  ShowOnFrontScreen: 'Show On Front Screen',
  ShowIncludesExcludes: 'Show Includes Excludes',
  HandoverGates: 'Handover Gates',
  HandoverAddEditDocument: 'Handover Edit Document',
  HandoverPreviewDocument: 'Handover Preview Document',
  WithAttachments: 'With Attachments',
  LookupDocumentCode: 'Lookup Document Code',
  AssignToMe: 'Assign To Me',
  AttachmentFile: 'Attachment File',
  AttachmentDescription: 'Attachment Description',
  AttachmentLinks: 'Attachment Links',
  HandoverTypes: 'Handover Types',
  OperationProgressMethod: 'Operation Progress Method',
  EnterSavedSearchNameandclickSave: 'Enter Saved Search Name and click Save',
  NoOfPersonnel: 'No Of Personnel',
  WorkOrderDetails: 'Work Order Details',
  NoSearchCriteria: 'No search criteria',
  Pleaseenterasearchname: 'Please enter a search name',
  // 通知消息
  ExistingHandovers: 'Existing Handovers',
  // 多选是没有选择任何项
  NotSelected: 'No items selected',
  // 删除成功
  DeleteSuccessfully: 'Delete successfully',
  // 操作成功
  OperationSuccessful: 'Operation successful',
  // 操作失败
  Operationfailed: 'Operation failed',
  EditSignOffs: 'Edit Sign Offs',
  preservationCompletionStatus: 'Preservation Completion Status',
  SigneOffLocation: 'Signe Off Location',
  DueDate: 'Due Date',
  Frequency: 'Frequency',
  SignerNameAndDateRequired: 'Signer Name And Date Required',
  ImportsDigitalDocument: 'Imports Digital Document',
  LocksJobCard: 'Locks Job Card',
  EstimatedHours: 'Estimated Hours',
  TagITRTaggedItem: 'Tag ITR Tagged Item',
  JobCardDescription: 'Job Card Description',
  Narrative: 'Narrative',
  ApprovalComments: 'Approval Comments',
  ReorderAttachments: 'Reorder Attachments',
  AddJobCard: 'Add Job Card',
  TagType: 'Tag Type',

  EndDate: 'End Date',

  ProcedureName: 'Procedure Name',
  HeatTrace: 'Heat Trace',
  UnitOfMeasure: 'Unit Of Measure',
  Contractor: 'Contractor',
  TestPressure: 'Test Pressure',
  TestMedium: 'Test Medium',
  TestDuration: 'Test Duration',
  DateAddedToTagSet: 'Date Added To TagSet',
  DateRemovedFromTagSet: 'Date Removed From TagSet',
  ExportTaggedItemDrawings: 'Export Tagged Item Drawings',
  ExportTaggedItemITRs: 'Export Tagged Item ITRs',
  ExportTaggedItemProcedures: 'Export Tagged Item Procedures',
  ExportTaggedItemPWLs: 'Export Tagged Item PWLs',
  ExportTags: 'Export Tags',
  ExportCables: 'Export Cables',
  ExportTestPackMechanicalJoints: 'Export Test Pack Mechanical Joints',
  NumberOfBolts: 'Number Of Bolts',
  DocumentFormat: 'Document Format',
  GeneratedAt: 'Generated At',
  ReportOptions: 'Report Options',
  Pleasechoosethepageorientation: 'Please choose the page orientation',
  Pleasechoosethepagesize: 'Please choose the pagesize',
  RunPDF: 'Run PDF',
  RunExcel: 'Run Excel',
  ReportGroup: 'Report Group',
  ScheduledReportReport: 'Scheduled Report',
  ScheduledReportReportFilter: 'Scheduled Report Report Filter',
  MaxDocumentsToRetain: 'Max Documents To Retain',
  Scheduled: 'Scheduled',
  Every: 'Every',
  Week: 'Week',
  On: 'on',
  At: 'at',
  EverydayoftheWeek: 'Every day of the Week',
  EmailAddresses: 'Email Addresses',
  SelectAReport: 'Select a Report',
  Filters: 'Filters',
  EditFilters: 'Edit Filters',
  RemovePreviousReports: 'Remove previous reports',
  PreservationProgressMethod: 'Preservation Progress Method',
  PreservationWindowBefore: 'Preservation Window Before',
  PreservationWindowAfter: 'Preservation Window After',
  StorageUsed: 'Storage Used',
  EnableAuthorisedPersonSignatures: 'Enable Authorised Person Signatures',
  EnableCleanEnergy: 'Enable Clean Energy',
  EnablePreservation: 'Enable Preservation',
  EnableProcedures: 'Enable Procedures',
  EnableEx: 'Enable Ex',
  EnableMaterials: 'Enable Materials',
  EnableCertificationGrouping: 'Enable Certification Grouping',
  LockImperiumFields: 'Lock Imperium Fields',
  EnableProcessBuilder: 'Enable Process Builder',
  MOCAutoNumbering: 'MOC Auto Numbering',
  HideEmpty: 'Hide Empty Systems/Sub Systems',
  EnablePolarionID: 'Enable Polarion ID',
  LockDigitalDocumentComments: 'Lock Digital Document Comments',
  CountryName: 'Country Name',
  CountryNameEn: 'Country Name En',
  CountryCode: 'Country Code',
  TaggedItemsLimit: 'Tagged Items Limit',
  Features: 'Features',
  AutoNumberPunchListItems: 'Auto Number Punch List Items',
  EnableHeaderFieldsReport: 'Enable Header Fields Report',
  PunchListMode: 'Punch List Mode',
  TimeZone: 'Time Zone',
  TagITRAutoAllocation: 'Tag ITR Auto Allocation',
  TagPWLAutoAllocation: 'Tag PWL Auto Allocation',
  QPacksMode: 'Q Packs Mode',
  EnablePrimaryAndSecondaryHandovers: 'Enable Primary And Secondary Handovers',
  EnableHandoverRiskAssessmentFeature: 'Enable Handover Risk Assessment Feature',
  EnableManualNumberingOfOperations: 'Enable Manual Numbering Of Operations',
  EnableAssurance: 'Enable Assurance',
  EnableSubcontractorView: 'Enable Subcontractor View',
  EnableManualNumberingofOperations: 'Enable Manual Numbering of Operations',
  DModelConnection: '3D Model Connection',
  DigitalDocumentFooter: 'Digital Document Footer',
  // Engineering: 'Engineering',
  Engineering: 'Configuration',
  Entity: 'Entity',
  DownloadSmartGoDataDictionary: 'Download SmartGo Data Dictionary',
  SmartGoDataDictionary: 'For information on the loading order of information and the description of each table, please refer to the SmartGo Data Dictionary.Click to download',
  ProjectList: 'Project List',
  Projectnotfound: 'Project not found',
  Pleasetrycreatinganewproject: 'Please try creating a new project',
  Newproject: 'New project',
  SystemManagement: 'System Management',
  DataDictionary: 'Data Dictionary',
  nickname: 'Nick Name',
  surname: 'Sur Name',
  name: 'Name',
  UserName: 'User Name',
  password: 'Password',
  profile: 'Profile',
  country: 'Country',
  language: 'Language',
  English: 'English',
  Chinese: 'Chinese',
  Disable: 'Disable',
  LoginSuccessful: 'Login Successful',
  LoginFailed: 'Login Failed',
  LogoutSuccessful: 'Logout Successful',
  UserInfo: 'Personal Information',
  Datamodification: 'Data Modification',
  Basicinformation: 'Basic Information',
  PasswordRest: 'Password Rest',
  Oldpassword: 'Old password',
  Newpassword: 'New password',
  Confirmpassword: 'Confirm password',

  Permissioncharacters: 'Permission Characters',
  Chinesename: 'Chinese Name',
  Confirmpassword: 'Confirm password',
  nickname: 'nick name',
  Permissioncharacters: 'Permission Characters',
  chinesename: 'Chinese Name',
  PermissionManagement: 'Permission Management',
  EditFooter: 'Edit Footer',
  EditFooterforTutorial: 'Edit Footer for Tutorial',
  Left: 'Left',
  LeftText: 'Left Text',
  Centre: 'Centre',
  CentreText: 'Centre Text',
  Right: 'Right',
  RightText: 'Right Text',
  FooterTutorial: 'Footer Tutorial',
  FooterHistory: 'Footer History',
  ThirdPartyBy: 'Third Party By',
  ThirdPartyDate: 'Third Party Date',
  RaiseDeleteCCCs: 'Raise/Delete CCCs',
  RaiseCCC: 'Raise CCC',
  RaiseRFSU: 'Raise RFSU',
  HandoverTypeDocument: 'Handover Type Document',
  HandoverTypeCoverSheet: 'Handover Type Cover Sheet',
  FilterReport: 'Filter Report',
  Attachmentdeletionsuccessful: 'Attachment Deletion Successful',
  Scope: 'Scope',
  AssignedTagPWLs: 'Assigned Tag PWLs',
  MenuName: 'Menu Name',
  Icon: 'Icon',
  MenuNameCN: 'Menu Name (Chinese)',
  Sort: 'Sort',
  Editmenu: 'Edit Menu',
  TopMenu: 'Top Menu',
  MenuType: 'Menu Type',
  MenuMing: 'Menu Name (Chinese)',
  Thispermissionhasbeenassigned: 'This permission has been assigned',
  AssignPermissions: 'Assign Permissions',
  RoleList: 'Role List',
  RolesAssign: 'Roles Assign',
  Fileverificationpassed: 'File verification passed',
  Unabletoreadfile: 'Unable to read file',
  FileFormat: 'Cannot import this file. File must be in .csv or .xlsx format',
  FileEmpty: 'The file contains no data. Please check and upload a valid file.',
  ConfirmDelete: 'Confirm Delete',
  DataDelete: 'Are you sure you want to delete this data?',
  AddUser: 'Add User',
  View: 'View',
  AginRole: 'The role has been assigned.',
  CharacterOperationSuccessful: 'Character Operation Successful.',
  RoleUnbindingFailed: 'Role unbinding failed, please try again later.',
  SelectedRole: 'Assigned role',
  ExpandCollapse: 'Expand/Collapse',
  SelectAllSelectNone: 'Select All/Select None',
  AssignedMenu: 'Assigned Menu',
  Directory: 'Directory',
  MeNu: 'Menu',
  Enable: 'Enable',
  Menupermissions: 'Menu Permissions',

  // 2025-4-23
  PleaseselectatabletoExport: 'Please select a table to Export.',
  RoleName: 'Role Name',
  AddRole: 'Role',

  PermissionName: 'Permission Name',
  PermissionIdentifier: 'Permission Identifier',
  MenuStatus: 'Menu Status',
  Show: 'Show',
  Hide: 'Hide',
  ParentMenu: 'Parent Menu',
  PrerequisiteProcedure: 'Prerequisite Procedure',
  DocumentOwner: 'Document Owner',
  CheckedBy: 'Checked By',
  Transmittal: 'Transmittal',
  AdditionalInformation: 'Additional Information',
  AuthorisedStartedDate: 'Authorised Started Date',
  CheckedDate: 'Checked Date',
  DocumentRequiredByDate: 'Document Required By Date',
  Title: 'Title',
  ParentProcedureSkeletonSection: 'Parent Procedure Skeleton Section',
  ProcedureSkeletonSectionNumber: 'Procedure Skeleton Section Number',
  TransmittalNumber: 'Transmittal Number',
  ParentProcedureSection: 'Parent Procedure Section',
  ProcedureSectionNumber: 'Procedure Section Number',
  ProcedureStepNumber: 'Procedure Step Number',
  DeleteOperationCanceled: 'Deletion operation canceled',
  PleaseEnterOldPassword: 'Please enter old password',
  Passwordresetsuccessfully: 'Password reset successfully',
  Passwordresetfailed: 'Password reset failed',
  OkPassword: 'OK',

  //5-20
  ClosedBy: "Closed By",
  AnsweredBy: 'Answered By',
  AnsweredDate: 'Answered Date',
  ClarificationDetails: 'Clarification Details',
  ImpactNo: 'Impact No',
  ProcedureDrawing: 'Procedure Drawing',
  PACToBeIssued: 'PAC To Be Issued',
  NCRToBelssued: 'NCR To Be lssued',
  //5-22
  TagPWLTaggedItem: 'Tag PWL Tagged Item',
  TagPWLTaggedItemLocation: 'Tag PWL Tagged Item Location',
  TagPWLFrequency: 'Tag PWL Frequency',
  ExportAsTagPWLs: 'Export As Tag PWLs',
  SelectColumns: 'Select Columns',
  //5-26
  AsBuiltDrawings: 'As Built Drawings',
  IsDraft: 'Is Draft',
  ViewBoard: 'View Board',
  //5-28
  NotStarted: 'Not Started',
  InProgress: 'In Progress',
  ChecksheetComplete: 'Checksheet Complete',
  //5-30
  TrackerType: 'Tracker Type',
  PlannedDueDate: 'Planned Due Date',
  //6-3
  AuthorisedPersonProfession: 'Authorised Person Profession',
  TrackerCategory: 'Tracker Category',
  TrackerSubCategory: 'Tracker Sub Category',
  //6-4
  AuthorisedPersonSubcontractorName: 'Authorised Person Subcontractor Name',
  AssignedToNotificationGroup: 'Assigned To Notification Group',
  IssuedAsPaperOrPdfVersion: 'Issued As Paper Or Pdf Version',
  //6-9
  ExportAsTagITRs: 'Export As Tag ITRs',
  ChooseColumns: 'Choose Columns',
  Back: 'Back',
  OVERALL: 'Overall',
  HandoverCont: 'Handovers',
  BOARD: 'Board',
  //6-16
  IsComplete: 'Is Complete',
  Weighting: 'Weighting',
  //6-19
  PunchListItemCompletionStatus: 'Punch List Item Completion Status',
  IsDefaultStatus: 'Is Default Status',
  IsRejected: 'Is Rejected',
  AssuranceTrackerCompletionStatus: 'Assurance Tracker Completion Status',
  //6-23
  ExportAsTagPWLs: 'Export As Tag PWLs',
  AcceptItems: 'Accept Items',
  //7-9
  PulledLengthUnit: 'Pulled Length Unit',
  //7-18
  AddCheckBox: 'Add Check Box',
  CheckBoxLabels: 'Check Box Labels',
  PunchListCheckBox: 'Punch List Check Box',
  TRANSLATE: 'The name of the checkbox is limited to 3 characters',
  //7-28
  Certificate: 'CERTIFICATE',
  Certificates: 'Certificate',
  ITRCheckSheet: ' ITR-Check Sheet',
  //7-31
  SigninwithyourSmartGoAccount: 'Sign in with your SmartGo Account',
  RememberMe: 'Remember Me',
  Forgotyourpassword: 'Forgot your password',
  EnteryourEmail: 'Enter your Email',
  Enteryourpassword: 'Enter your password',
  EnterPassword: 'Enter Password',
  Signin: 'Sign in',
  Workbenches: 'Work benches',
  FullScreen: 'Full Screen',
  ExitFullScreen: 'Exit Full Screen',
  UserCenter: 'User Center',
  LogOut: 'Log Out',
  CloseAll: 'Close All',
  CloseOther: 'Close Other',
  Entersomething: 'Enter something',
  Roles: 'Roles',
  PermissionList: 'Permission List',

  AssignedTagITRs: 'Assigned TagITRs',
  NoCertificateDataAvailable: 'No Certificate Data Available',
  TAGITRS: 'TAG ITRS',
  NoTAGITRSDataAvailable: 'No TAG ITRS Data Available',
  PUNCHLISTITEM: 'PUNCH LIST ITEM',
  NoPUNCHLISTITEMSDataAvailable: 'No PUNCH LIST ITEMS Data Available',
  NoPLANNEDVSACTUALPROGRESSDataAvailable: 'No PLANNED VS ACTUAL PROGRESS Data Available',
  MOCS: 'MOCS',
  NoMOCDataAvailable: 'No MOC Data Available',
  Total: 'Total',
  Completed: 'Completed',
  TotalITRs: 'Total ITRs',
  TotalPILs: 'Total PLIs',
  TotalMOCs: 'Total MOCs',
  SKYLINEOUTSTANDINGUPCOMING: 'SKYLINE : OUTSTANDING & UPCOMING',
  NoSKYLINEDataAvailable: 'No SKYLINE Data Available',
  PLANNEDVSACTUALPROGRESS: 'PLANNED VS ACTUAL TAG ITR PROGRESS',
  TagPWLsTotal: 'Tag PWLs Total',
  SELECTTYPE: 'SELECT TEMPLATE TYPE',
  Nofile: 'No file was uploaded. Please choose a file.',
  PleaseselectTable: 'Please select a table to import first.',
  Fileandtable: 'File and table mismatch. Please check and try again.',
  AnFile: 'An error occurred while verifying the file.',
  Fileverification: 'File verification failed, please check carefully.',
  FileContains: 'The file contains no fields marked as required',
  homeList: {
    assignedTagITRs: "Tag ITRs",
    assignedPunchListItems: "Punch List Items",
    assignedCertificate: "Certificate",
    assignedTagPWLs: "Preservation Activities",
    assignedORA: "ORA",
    complete: "complete",
  },
  //2025-08-01
  SureWant: 'Are you sure you want to log out?',
  PleaseSelectFile: 'Please Select File',
  AddItems: 'Add Items',
  RowsLoaded: 'Rows Loaded',
  ExCertifyingBody: 'Ex Certifying Body',
  ExRatedModel: 'Ex Rated Model',
  // 搜索
  SimpleSearch: 'Simple Search',
  AdvancedSearch: 'Advanced Search',
  RefreshView: 'Refresh View',
  FromCreatedDate: 'From Created Date',
  ToCreatedDate: 'To Created Date',
  CreatedDate: 'Created Date',
  FromUpdatedDate: 'From Updated Date',
  ToUpdatedDate: 'To Updated Date',
  SelectDate: 'Select Date',
  Theprimaryidentifierforanitem: 'The primary identifier for an item.',
  Ageneraldescriptionoftheitem: 'A general description of the item.',
  Datetheitemwasadded: "Date the item was added.'From Created Date' and 'To Created Date' can be used to specify a range.",
  Datetheitemwaslastupdated: "Date the item was last updated. 'From Updated Date' and 'To Updated Date' can be used to specify a range.",
  ImportSetting: 'Import Setting',
  ImportTable: 'Import Table',
  StoredAsJson: 'Stored As Json',
  TotalAdded: 'Total Added',
  FromSignedOffDate: 'From Signed Off Date',
  ToSignedOffDate: 'To Signed Off Date',
  SignedOffDate: 'Signed Off Date',
  TagITRComments: 'Tag ITR Comments',
  FromLastGeneratedDate: 'From Last Generated Date',
  ToLastGeneratedDate: 'To Last Generated Date',
  TagITRsSubcontractorName: 'Tag ITRs Subcontractor Name',
  InspectionandTestRecords: 'Inspection and Test Records (ITRs) are records (traditionally paper-based checklists, but increasingly available digitally) used to certify that tagged equipment has been properly built and tested in line with agreed processes and procedures by approved and competent personnel. The ITRs (also referred to as check sheets, tally sheets and certificates) include a list of tasks, measurements and activities that should be completed to verify the status of the equipment concerned. While the design, content, naming and terminology of ITRs will vary between different companies, locations and projects their ultimate purpose is the same: To ensure the safety of equipment being certified.',
  TestReferenceisan: 'Test Reference is an optional field that allows a way of differentiating between two ITRs of the same type (e.g. QED-A01A) assigned to the same Tag. Examples of values entered in Test Reference may be \u0027Onshore\u0027, \u0027Offshore\u0027, \u0027Retest\u0027,\u00271\u0027,\u00272\u0027,\u00273\u0027,etc.',
  EforElectrical: 'The Discipline of an item. \n\n A Discipline represents a trade or area of expertise that individuals may specialise in or assume responsibility for, and is also used to categorise equipment. Common examples of disciplines would be Electrical, Mechanical, Safety, Fire \u0026 Gas etc. \n\n Often these are named using a single letter such as E for Electrical.',
  TheITRClass: 'The ITR Class is normally used to represent the general phase or activity to which the ITR applies, with the most common ITR Classes either MC and PC( which refer to Mechanical Completion and Pre-Commissioning) or CN and CM (which refers to Construction and Commissioning). A wide variety of other ITR Classes are also used as appropriate.',
  ASystemis: 'A System is a functional object that itself is a collection of functional objects (Subsystems) that form a network to provide a type of service, or serve a common purpose. \n\n It\u0027s worth noting that the objects within a System do not have to be physically connected.',
  Thenameof: 'The name of the Authorised Person who signed-off the item or document.',
  ASubsystemis: 'A Subsystem is a functional object that represents a collection of items that serve a common purpose. \n\n As with Systems, the items themselves do not have to be physically connected. Certification Groupings provide a means of associating Tag ITRs together by Subsystem and Discipline for handover.',
  Thedateon: 'The date on which the item was signed off. \u0027From Signed Off Date\u0027 and \u0027To Signed Off Date\u0027 can be used to specify a range.',
  Phasesprovide: 'Phases provide a means by which a Level C can be subdivided into distinct periods of time during which work will occur.',
  Inliteralterms: 'In literal terms, an entry in the Tag ITR Completion Status register represents a value that can be recorded against a Tag ITR to represent what state it is in. \n\n In a more meaningful sense, each Tag ITR Completion Status is the answer to the question \u0027What is the status of the ITR?\u0027  \n\n Suggested entries for this register would be values such as \u0027Completed\u0027, \u0027Not Completed\u0027, \u0027Not Required\u0027, etc. however it is up to the user to decide, and populate, the Tag ITR Completion Status register to their satisfaction. \n\n Aside from Name and Description, an entry in the Tag ITR Completion Status register also has values for Is Default and Requires Reason. The former, when set to true, results in the value being set as the default status when signing off a Tag ITR, while the latter results in a requirement for an entry in the Tag ITR Comments field before saving can occur. Failure to do so will result in a prompt to the user to complete this information.',
  Proceduresanddrawings: 'Job Cards (also known as Job Packs) represent a further subdivision of Work Packs and detail jobs to be undertaken at a facility. They exist to authorise and instruct the workers to perform the listed task and contain task guidelines, safety information and other relevant documentation such as inspection procedures and drawings.',
  Usedtouniquely: 'Document Codes are used to uniquely identify each document within hub2. Each Handover, Punch List Item, Tag PWL and Tag ITR receives a unique document code.',
  Commentsfield: 'The comments field can be used to record any miscellaneous information related to the Tag ITR.',
  ExamplesofEquipment: 'Equipment Type represents a general categorisation of an item of Equipment and allows ITRs to be assigned (or recommended) based on this categorisation via the Equipment Type to ITR table. Common examples of Equipment Types would include Junction Boxes, Transmitters,  Distribution Boards, and Valves.',
  Canbeused: 'Equipment Status can be used to further divide a group of Tags with the same Equipment Type. The purpose of Equipment Status is solely to allow more detailed and refined control over the Equipment Type to ITR allocation/recommendation and as such the field is optional.',
  Setofusers: '"Description": "Subcontractor Name is an optional field which allows a way of differentiating between different scopes of work assigned to a specific set of users."',
  Locationdenotes: 'Location denotes the physical space occupied by an item.',
  AParent: 'A Parent Tag is a grouping (available from the Reference Tables) that can be used either to represent a collection of Tagged Items that are related or that, when taken together, constitute a larger functional object. ',
  Thecomments: 'The comments field can be used to record any miscellaneous information related to an item.',
  Canhave: 'Tagged Items can have Ignore Equipment Type to ITR checked to allow them to be excluded from the automatic allocation/suggestion rules defined by the Equipment Type to ITR table.',
  SourceDrawingrefers: 'Source Drawing refers to the Drawing which primarily identifies the item in question.',
  Convention: 'The Type of the Drawing. \n\n Drawings can cover a range of different types of illustration, including Isometrics, Process and Instrumentation Diagrams and General Arrangement Drawings amongst others. They serve to communicate information visually in a variety of ways, with the type of drawing used determined both by convention and what is most effective for serving the purpose required.',
  Commissionanobject: 'A Procedure is a set of logically sequenced instructions for the way of executing a class of activity.  \n\n There can be many different types of Procedures with the main ones in hub2 being Commissioning Procedures which is a Procedure with a step by step description of activities required to A Procedure is a set of logically sequenced instructions for the way of executing a class of activity.  \n\n There can be many different types of Procedures with the main ones in hub2 being Commissioning Procedures which is a Procedure with a step by step description of activities required to commission an object.',
  TheTypeof: 'The Type of the Procedure. \n\n A Procedure is a set of logically sequenced instructions for the way of executing a class of activity.  \n\n There can be many different types of Procedures with the main ones in hub2 being Commissioning Procedures which is a Procedure with a step by step description of activities required to commission an object.',
  Datetheitem: 'Date the item was added.\u0027From Created Date\u0027 and \u0027To Created Date\u0027 can be used to specify a range.',
  SpecifyA: 'Date the item was last updated. \u0027From Updated Date\u0027 and \u0027To Updated Date\u0027 can be used to specify a range.',
  CabelATagrepresents: "A Tag represents functionality provided by physical equipment within a facility, with the name 'Tag' arising from the equipment tag assigned (and usually physically attached) to the equipment for identification purposes. While this does mean that, taken literally, the tag is the label itself, it is usually used to refer to the function of the equipment. It should be noted that if a piece of equipment, or part of a piece of equipment, is replaced this does not constitute a different tag. Therefore, if Tag 'A' was a compressor with the Serial Number '0001' and it was replaced with compressor with serial number '0002', it would still be Tag 'A'.",
  Disciplinerepresents: 'Discipline represents a trade or area of expertise that individuals may specialise in or assume responsibility for, and is also used to categorise equipment. Common examples of disciplines would be Electrical, Mechanical, Safety, Fire \u0026 Gas etc. \n\n Often these are named using a single letter such as E for Electrical.',
  SubcontractorNameisanoptional: 'Subcontractor Name is an optional field which allows a way of differentiating between different scopes of work assigned to a specific set of users.',
  Thephysical: 'The physical space where the item originates',
  Manydifferent: 'A Procedure is a set of logically sequenced instructions for the way of executing a class of activity.  \n\n There can be many different types of Procedures with the main ones in hub2 being Commissioning Procedures which is a Procedure with a step by step description of activities required to commission an object.',
  Representsfunctionality: 'A Tag represents functionality provided by physical equipment within a facility, with the name \u0027Tag\u0027 arising from the equipment tag assigned (and usually physically attached) to the equipment for identification purposes. \n\n While this does mean that, taken literally, the tag is the label itself, it is usually used to refer to the function of the equipment. \n\n It should be noted that if a piece of equipment, or part of a piece of equipment, is replaced this does not constitute a different tag. \n\n Therefore, if Tag \u0027A\u0027 was a compressor with the Serial Number \u00270001\u0027 and it was replaced with compressor with serial number \u00270002\u0027, it would still be Tag \u0027A\u0027.',
  InspectionAnd: 'Inspection and Test Records (ITRs) are records (traditionally paper-based checklists, but increasingly available digitally) used to certify that tagged equipment has been properly built and tested in line with agreed processes and procedures by approved and competent personnel. \n\n The ITRs (also referred to as check sheets, tally sheets and certificates) include a list of tasks, measurements and activities that should be completed to verify the status of the equipment concerned. \n\n While the design, content, naming and terminology of ITRs will vary between different companies, locations and projects their ultimate purpose is the same: To ensure the safety of equipment being certified.',
  ItemThephysical: 'The physical space where the item terminates.',
  Whetherapipe: 'Whether a pipe is supported by a trace heating (also known as surface heating) system to ensure it remains at the correct temperature.',
  Thedimensionsoftheitem: 'The dimensions of the item.',
  ALineIs: 'A Line is defined as a section of pipe. Lines can be connected via spools; a short section of pipe with fittings that allow one pipe line to connect to another. Like spools, lines can also be part of a test pack.',
  Howmanybolts: 'How many bolts are required for connecting this joint',
  Itemwassignedoff: 'The date on which the item was signed off.',
  TheHandoverGating: 'The Handover Gating determines the scope and the ordering of the Handover within the overall project, serving to answer the questions: Which certificates/ITRs are covered by this Handover and when in the complete Handover process should this particular Handover occur? \n\n Both questions are answered with a single field: The Handover Gate Number. \n\n This field acts as both a link between the Handover and the ITR Classes as well as means of ordering the Handover within the project. \n\n The ITR Class is normally used to represent the general phase or activity to which the ITR applies, with the most common ITR Classes either MC and PC( which refer to Mechanical Completion and Pre-Commissioning) or CN and CM (which refers to Construction and Commissioning). A wide variety of other ITR Classes are also used as appropriate.',
  Approvedandcompetent: 'The Discipline of the Inspection and Test Record (ITR). \n\n Inspection and Test Records (ITRs) are records (traditionally paper-based checklists, but increasingly available digitally) used to certify that tagged equipment has been properly built and tested in line with agreed processes and procedures by approved and competent personnel. \n\n Discipline represents a trade or area of expertise that individuals may specialise in or assume responsibility for, and is also used to categorise equipment. Common examples of disciplines would be Electrical, Mechanical, Safety, Fire & Gas etc. Often these are named using a single letter such as E for Electrical.',
  Actvitiywithin: 'Actvitiy within hub2 represents Level 3 in the recommended Work Breakdown Structure and as such exists as the parent of Job Cards and a child of Level E.\n\n  The term Activity is often used interchangeably with Work Pack or Work Package, however hub2 treats them as separate but equivalent. \n\n The Activity is intended to represent the Planning Component and as such represents a period of time utilised (within a larger work scope), rather than a physical document.',
  Recommendeddata: "The parent Work Pack for the Job Card. \n\n Work Packs (also called Work Packages, Construction Work Packs and Construction Work Packages) are the lowest level represented on a project's Work Break Down structure (WBS) and are used as a way of grouping tasks within a Work Scope (which, when following recommended data population guidelines, maps to Level E of the hub2 data structure). \n\n In a literal sense, a Work Pack is a collection of documents necessary for the completion of a group of tasks within the timescale specified in the Project plan. This will include the Tasks to be completed and the Equipment and Materials required to complete them. \n\n Assembly of Work Packs is considered to be one of the most time-consuming aspects of Project Management.",
  FromAcceptedDate: 'From Accepted Date',
  ToAcceptedDate: 'To Accepted Date',
  ToIssuedDate: 'To Issued Date',
  FromIssuedDate: 'From Issued Date',
  FromCompletedDate: 'From Completed Date',
  ToCompletedDate: 'To Completed Date',
  IssuedAsPaperPDFVersion: 'Issued AsPaper / PDF Version',
  Longerandmore: 'Longer and more detailed description, useful for items such as MOC and Punch List Items.',
  PunchListisagrouping: "A Punch List is a grouping of Punch List Items (often called 'PLIs'). \n\n Punch Lists Items are used to record items of outstanding work which should have been completed previously. \n\n This could include examples such as missing insulation or trace heating on pipework, painting not complete or paint touch-ups required, outstanding earthing of instruments or junction boxes, amongst many others.",
  Arrangement: "Punch List Items are assigned a Punch List Category which is usually used to indicate the severity of the defect. \n\n A common, and simple, arrangement is to create two Punch List Item Categories, one with the Name 'A' and one with the Name 'B'. Category 'A' is used for safety related defects, while 'B' is used for others. \n\n The ability to define Punch List Item Categories is however completely at the discretion of the user and so may deviate completely from the above example, which is provided for general information only and does not constitute guidance on this subject.",
  Disciplinerepresents: 'The Discipline of an item. \n\n A Discipline represents a trade or area of expertise that individuals may specialise in or assume responsibility for, and is also used to categorise equipment. Common examples of disciplines would be Electrical, Mechanical, Safety, Fire & Gas etc. \n\n Often these are named using a single letter such as E for Electrical.',
  TestReferenceAD: "Test Reference is an optional field that allows a way of differentiating between two ITRs of the same type (e.g. QED-A01A) assigned to the same Tag. Examples of values entered in Test Reference may be 'Onshore', 'Offshore', 'Retest','1','2','3',etc.",
  PreservationWorkLists: "Preservation Work Lists' (PWLs) are used to record the completion of preservation tasks, and can be assigned to Tags, in a similar fashion to ITRs. \n\n The difference is that PWLs are part of a regular schedule of maintenance on unused equipment, while ITRs are used to sign-off that installed equipment is safe and has been properly tested as part of the Handover process (in which the ultimate goal is to start, or restart, the facility).",
  OutstandingWork: 'Outstanding Work Lists (OWLs) and OWL Tasks are used to document work which has already been identified as incomplete, before Handover. \n\n This is in contrast to Punch Lists and PL Items, which are used to capture incomplete work which had not previously been identified.',
  Thenameof: 'The name of the Authorised Person who accepted the item or document as complete.',
  WorkItem: 'The amount of time allocated to a task or work item.',
  PreservationWork: 'The Date when Preservation Work for this item is due to cease.',
  FromRaisedDate: 'From Raised Date',
  ToRaisedDate: 'To Raised Date',
  FromPlannedDate: 'From Planned Date',
  ToPlannedDate: 'To Planned Date',
  FromDueDate: 'From Due Date',
  ToDueDate: 'To Due Date',
  FromEndDate: 'From End Date',
  ToEndDate: 'To End Date',
  FromClearedDate: 'From Cleared Date',
  ToClearedDate: 'To Cleared Date',
  HandoverCertificates: 'Handover Certificates, usually referred to simply as \u0027Handovers\u0027 are used to guarantee Technical Integrity when responsibility is being transferred between Authorities.',
  Miscellanousinformationrelated: 'Miscellanous information related to the Handover can be stored in the Comments field.',
  Authorityisscheduledtobegin: 'The date by which the transfer of authority is scheduled to begin.',
  Authorityisscheduledtofinish: 'The date by which the transfer of authority is scheduled to finish.',
  Willbereturned: 'When ticked, only Handovers which are associated with Completed ITRs (those which have a Completed By and Completed Date) will be returned',
  FromPlannedStartDate: 'From Planned Start Date',
  ToPlannedStartDate: 'To Planned Start Date',
  FromPlannedFinishDate: 'From Planned Finish Date',
  ToPlannedFinishDate: 'To Planned Finish Date',
  FromReviewedDate: 'From Reviewed Date',
  ToReviewedDate: 'To Reviewed Date',
  ThefullfilenameforanAttachment: 'The full file name for an Attachment.',
  ThedescriptionofanuploadedAttachmentfile: 'The description of an uploaded Attachment file.',
  Unusedequipment: 'Preservation Work Lists\u0027 (PWLs) are used to record the completion of preservation tasks, and can be assigned to Tags, in a similar fashion to ITRs. \n\n The difference is that PWLs are part of a regular schedule of maintenance on unused equipment, while ITRs are used to sign-off that installed equipment is safe and has been properly tested as part of the Handover process (in which the ultimate goal is to start, or restart, the facility).',
  AQuality: 'A Quality Pack (Q Pack) is a collection of Quality Steps, or tasks, which must be completed for an individual Tagged Item.',
  ManagementofChange: 'Management of Change (MOC) is the process by which potential deviations from original scope/design are tracked.',
  Programshould: 'File extensions are the part of a file name that comes after the full stop. As an example in the file Help.txt the extension is .txt. \n\n File extensions identify what type of information is stored in a file and what program should be used to open it.',
  Detailed: 'Detailed',
  Summary: 'Summary',
  Misc: 'Misc',
  NoHandoverhasaPlannedFinishDateset: 'No Handover has a Planned Finish Date set',
  LevelAisrepresents: 'Level A is the \u0027company\u0027/\u0027tenant\u0027 level, and represents settings that are \u0027company-wide\u0027.',
  Sandpit: 'Sandpit',
  Procedureswhenverifying: 'Name of the Authorised Person who completed the item. \n\n Usually used for Tag ITRs, Test Packs and Procedures when verifying the Completion Status of an item.',
  Itemwascompleted: 'Date when the item was completed.  \n\n Usually used for Tag ITRs, Test Packs and Procedures when verifying the Completion Status of an item.',
  ProcedureSystem: 'Procedure System',
  FromActualStartDate: 'From Actual Start Date',
  ToActualStartDate: 'To Actual Start Date',
  Author: 'Author',
  FromAuthorStartedDate: 'From Author Started Date',
  ToAuthorStartedDate: 'To Author Started Date',
  AuthorStartedDate: 'Author Started Date',
  ApprovedForIssueBy: 'Approved For Issue By',
  FromCheckedDate: 'From Checked Date',
  FromApprovedForIssueDate: 'From Approved For Issue Date',
  ToApprovedForIssueDate: 'To Approved For Issue Date',
  ApprovedForIssueDate: 'Approved For Issue Date',
  FromExecutionActualStartDate: 'From Execution Actual Start Date',
  ToExecutionActualStartDate: 'To Execution Actual Start Date',
  ExecutionActualStartDate: 'Execution Actual Start Date',
  FromDocumentRequiredByDate: 'From Document Required By Date',
  ToDocumentRequiredByDate: 'To Document Required By Date',
  ProcedureDrawingType: 'Procedure Drawing Type',
  ToCheckedDate: 'To Checked Date',
  Proceduresarecommonlysub: 'Procedures are commonly sub-divided into separate sections, which in hub2 are represented via Procedure Sections.',
  Nameofthe: 'Name of the Authorised Person who completed the Procedure Section.',
  Helevelabove: 'Name of the Authorised Person who completed the parent (the level above) of this Procedure Section',
  RaisePLs: 'Raise PLs',
  FromRevisionDate: 'From Revision Date',
  ToRevisionDate: 'To Revision Date',
  TheDisciplineof: 'The Discipline of the Inspection and Test Record (ITR). \n\n Inspection and Test Records (ITRs) are records (traditionally paper-based checklists, but increasingly available digitally) used to certify that tagged equipment has been properly built and tested in line with agreed processes and procedures by approved and competent personnel. \n\n Discipline represents a trade or area of expertise that individuals may specialise in or assume responsibility for, and is also used to categorise equipment. Common examples of disciplines would be Electrical, Mechanical, Safety, Fire \u0026 Gas etc. Often these are named using a single letter such as E for Electrical.',
  TheITRClass: 'The ITR Class is normally used to represent the general phase or activity to which the ITR applies, with the most common ITR Classes either MC and PC( which refer to Mechanical Completion and Pre-Commissioning) or CN and CM (which refers to Construction and Commissioning). \n\n A wide variety of other ITR Classes are also used as appropriate.',
  ThedefaultCompletionStatus: 'The default Completion Status is automatically selected for convenience. A user must manually change the field if they require a different Completion Status.',
  Denoteswhetherthedocument: 'Denotes whether the document is generated from a digital template (created and managed from the Digital Document section of hub2) or an external template created in a word processing program.',
  DigitalDocumentPartial: 'Digital Document Partial',
  TheHandoverGatingdetermines: "The Handover Gating determines the scopethe ordering of the Handover within the overall project, serving to answer the questions: Which certificates/ITRs are covered by this Handover and when in the complete Handover process should this particular Handover occur? \n\n Both questions are answered with a single field: The Handover Gate Number. \n\n This field acts as both a link between the Handover and the ITR Classes as well as means of ordering the Handover within the project.",
  StartDate: 'Start Date',
  Controlover: 'The Equipment Status of the Line. \n\n Equipment Status can be used to further divide a group of Tags with the same Equipment Type. The purpose of Equipment Status is solely to allow more detailed and refined control over the Equipment Type to ITR allocation/recommendation and as such the field is optional.',
  Whentheitemisexpected: 'When the item is expected to be signed-off by',
  Describeshowregularly: 'Describes how regularly a  task should be performed. For example a Frequency of 7 would mean the task should be performed once per week.',
  ATagrepresents: "A Tag represents functionality provided by physical equipment within a facility, with the name 'Tag' arising from the equipment tag assigned (and usually physically attached) to the equipment for identification purposes. \n\n While this does mean that, taken literally, the tag is the label itself, it is usually used to refer to the function of the equipment. \n\n It should be noted that if a piece of equipment, or part of a piece of equipment, is replaced this does not constitute a different tag. \n\n Therefore, if Tag 'A' was a compressor with the Serial Number '0001' and it was replaced with compressor with serial number '0002', it would still be Tag 'A'.",
  Shouldcease: 'When work related to the item should cease.',
  Punch: 'PUNCH LIST ITEM',
  NoITRCheckSheetDataAvailable: 'No ITR-Check Sheet Data Available',
  Thephysicallocation: 'The physical location of the item being preserved.',
  Whocompleted: 'Name of the Authorised Person who completed the Procedure.',
  SpecificCategorisation: 'The specific categorisation of Tagged Item, e.g. Cable, Mech Joint, Test Pack, etc.',
  FromStartDate: 'From Start Date',
  ExpectedTime: 'Expected Time',
  ToStartDate: 'To Start Date',
  // 2025-08-04
  LeftImage: 'Left Image',
  RightImage: 'Right Image',
  UploadFiles: 'Upload Files',
  // 2025-08-05
  AddNewSignoffs: 'Add New Sign offs',
  Update: 'Update',
  AddHandoverType: 'Add Handover Type',
  ConfiguredFeatures: 'Configured Features',
  Select: 'Select',
  PunchListItemAutoNumber: 'Punch List Item Auto Number',
  Prefix: 'Prefix',
  Suffix: 'Suffix',
  NumberLength: 'Number Length',
  Enforcement: 'Enforcement',
  SystemAttachments: "System Attachments",
  SubSystemAttachments: 'Sub System Attachments',
  CableAttachments: 'Cable Attachments',
  Loginexpirationreminder: 'Login expiration reminder',
  Yourlogin: 'Your login information has expired, please log in again',
  Clearall: 'Clear all',
  ALLProject: 'ALL Project',
  MOCTypeName: 'MOC Type Name',


  tabs: {
    HEADER: "HEADER",
    HEADER_TABLE: "HEADER TABLE",
    TASK: "TASK",
    SIGN_OFF: "SIGN OFF",
    SETTINGS: "SETTINGS",
    PREVIEW: "PREVIEW"
  },
  Details: 'Details',
  Bookmark: 'Bookmark',
  Editable: 'Editable',
  Preview: 'Preview',
  TitleOptional: 'Title (Optional)',
  HideonPDF: 'Hide on PDF',
  DescriptionofTask: 'Description of Task',
  NumberNo: 'No.',
  EPCContractor: 'EPC Contractor',
  OQCompany: 'OQ Company',
  JobTitle: 'Job Title',
  AddDigitalDocumentfor: 'Add Digital Documentfor',
  EditDigitalDocumentfor: 'Edit Digital Document for',
  ITRDocument: 'ITR Document',
  Partofthe: 'Sign Offs are configured as part of the Digital Document',
  PunchListItemAttachments: 'Punch List Item Attachments',
  MCCAttachments: 'MCC Attachments',
  ProcedureAttachments: 'Procedure Attachments',
  MOCAttachments: 'MOC Attachments',
  FileReadError: 'File Read Error',
  ConsecutiveEmptyRows: 'Exceeded {count} consecutive empty rows, stopped checking remaining data.',
  RequiredErrorSection: 'Required Error Section',
  Couldnotprocessimport: 'Could not process import due to the following reason(s):',
  DuplicateErrorSection: 'Duplicate Error Section',
  ImportFileRow: 'Import File Row {row}',
  RaiseMcc: 'Raise Mcc',

  ImportFileLabel: 'Import File',
  NameValueLabel: 'Name Value',
  DuplicatedText: 'duplicated in',
  RowText: 'row',
  AndConnector: 'and',

  BeginRaisedDate: 'Begin Raised Date',
  EndRaisedDate: 'End Raised Date',
  BeginCreatedDate: 'Begin Created Date',
  EndCreatedDate: 'End Created Date',

  CommentsActions: 'Comments / Actions',

  EmptyRowsErrorSection: 'Empty Rows Error Section',


  RepetitionADD: 'Repetition ADD:',
  AddResults: 'Add Results',
  Items: 'Items',
  SavedList: 'Saved Add:',
  YouDoNotHavePermissionToImport: 'You Do Not Have Permission To Import',
  itrDescription: 'ITR Description',

  NoCCCSKYLINEDataAvailable: 'No CCC SKYLINE Data Available',
  NoMCCSKYLINEDataAvailable: 'No MCC SKYLINE Data Available',

  Goto: 'Go to',

  // 10-20
  TagQPack: 'Tag Q Pack',
  pwlDescription: 'PWL Description',
  ActionParty: 'Action Party',
  ActionPartyName: 'Action Party Name',

  ActionsTaken: 'Actions Taken',
  AddComments: 'Add Comments',
  TotalClosed: 'Total Closed',


  CreateNewDetailtedReort: 'Create New Detailed Reort',
  CreateNewSummaryReport: 'Create New Summary Report',

  OperationReadinessAssurance: 'Operation Readiness & Assurance',
  OperationsReadiness: 'Operations Readiness',
  TechnicalIntegritySafetyReadiness: 'Technical Integrity / Safety Readiness',
  ReliabilityMaintenanceReadiness: 'Reliability & Maintenance Readiness',
  InformationManagementReadiness: 'Information Management Readiness',
  HSSEReadiness: 'HSSE Readiness',
  SupplyChainReadinessLogistics: 'Supply Chain Readiness & Logistics',
  ResponsibleParty: 'Responsible Party',
  Categorization: 'Categorization',
  ResponsibleDepartment: 'Responsible Department',
  ReferenceDocumentsTitle: 'Reference Documents Title',
  DocumentReferenceNumber: 'Document Reference Number',
  RevisionNumber: 'Revision Number',
  ActionPlannedStartDate: 'Action Planned Start Date',
  ActionCompletionDate: 'Action Planned Completion Date',

  SubSystemDescription: 'Sub System Description',
  TaggedItemDescription: 'Tagged Item Description',
  TotalTags: 'Total Tags',
  CompletedITRs: 'Completed ITRs',
  OutstandingITRs: 'Outstanding ITRs',
  AccetpedBy:'Accetped By',

  SubSystemDiscipline: 'Sub System Discipline',

  OPERATIONREADINESSASSURANCE: 'OPERATION READINESS ASSURANCE',
  NoOPERATIONREADINESSASSURANCEDataAvailable: 'No OPERATION READINESS ASSURANCE Data Available',
  ContactUs: 'Contact Us',


  UserManual: 'User Manual',
  UserGuide: 'User Guide',
  VideoTutorial: 'Video Tutorial',


  SelectReportType: 'Select Report Type',
  SelectGroups: 'Select Groups',
  SelectGroupsPDFOnly: 'Select Groups (PDF Only)',
  Group: 'Group',
  GropDescription: 'Grop Description',
  LabelonReport: 'Label on Report',
  SeparateGroupingPage: 'Separate Grouping Page',
  ConfigureGroupingPagePDFOnly: 'Configure Grouping Page (PDF Only)',
  AddRow: 'Add Row',
  Row: 'Row',
  RemoveRow: 'Remove Row',
  Text: 'Text',
  HasInputSpace: 'Has Input Space',
  Remove: 'Remove',
  AddCloumn: 'Add Cloumn',
  SelectDetails: 'Select Details',
  ReportCode: 'Report Code',
  ReportName: 'Report Name',
  ReportCategory: 'Report Category',
  ColumnName: 'Column Name',
  HeaderonReport: 'Header on Report',
  TitleAboveHeader: 'Title (Above Header)',
  PDFWidth: 'PDF Width',
  XLSXWidth: 'XLSX Width',
  SaveReport: 'Save Report',
  Breakdown: 'Breakdown',
  PleaseEnterComment: 'Please Enter Comment',

  NotificationPreferences: 'Notification Preferences',
  NotificationType: 'Notification Type',
  NotificationMethod: 'Notification Method',
  PreferredSearchType: 'Preferred Search Type',
  Theme: 'Theme',
  ORAPriority: 'ORA Priority',

  TableName: 'Table Name',
  WillPreventHandover: 'Will Prevent Handover',
  ProcedureSkeletonStepNumber: 'Procedure Skeleton Step Number',
  PlannedCompletion: 'Planned Completion',
  ActualProgress: 'Actual Progress',
  Pleaseselectapieceofdatatoedit: 'Please select a piece of data to edit',
  ProjectReadinessWorkingStreams: 'Project Readiness Working Streams',
  ActivityDescription: 'Activity Description',
  Backlog: 'Back log',
  OperationReadinessStream: 'Operation Readiness Stream',

  PleaseSelectReportType: 'Please Select Report Type',
  PleaseInputReportCode: 'Please Input Report Code',
  PleaseInputReportName: 'Please Input Report Name',
  PleaseSelectAtLeastOneColumn: 'Please Select At Least One Column',
  CustomReportList: 'Custom Report List',
  FiletersCustomReport: 'Fileters Custom Report',
  Thereisnocustomreportinthedetails: 'There is no custom report in the details.',
  SelectReportOptions: 'Select Report Options',
  NoReportSelected: 'No Report Selected',
  ExportSuccess: "Export Success",
  ExportFailed: "Export Failed",

  UploadingPleaseWait: 'Uploading... Please Wait',


  Cannotdeletetagitr: "Cannot delete tagitr(s) because they are associated with punchlistitem items. Affected tagitr:",

  Planned: "Planned",
  SelectAll: "Select All",
  RejectAll: "Reject All",
  RejectItem: "Reject Item",
  PLIs: "PLIs",
  Attach: "Attach",
  AttachCurrentassociateditems: "Current associated items",
  AttachTotal: "in total",
  AttachSelectfile: "Select file (multiple file upload)",
  AttachSize: "The currently selected file will be automatically associated with all {count} items. Supports PDF format, single file no more than 20MB.",
  OtherDocument: "Document",
  ReviewAsBuiltDrawings: "Review As Built Drawings",
  MOCDisciplines: "MOC Disciplines",
  MOCTaggedItems: "MOC TaggedItems",
  MOCSystems: "MOC Systems",
  MOCSubSystems: "MOC Sub Systems",
  MOCAreas: "MOC Areas",
  MOCModules: "MOC Modules",
  MOCWorkPacks: "MOC Work Packs",
  MOCJobCards: "MOC Job Cards",
  RequiresClarification: "Requires Clarification",
  NCRToBeIssued: "NCR To BeIssued",
  MOCDrawings: "MOC Drawings",
  ResonsibleDepartment: " Resonsible Department",

  TagITRsEditDocument: "Tag ITRs Edit Document",
  Detail: "Details",
  TaskProgress: "Task Progress",
  Tasks: "Tasks",
  ShowAllTasks: "Show All Tasks",
  CollapseAllTasks: "Collapse All Tasks",
  NoDigltalDocumentAvallable: "No Digltal Document Avallable",
  AddPunchListItem: "Add Punch List Item",
  TagAttachments: "Tag Attachments",
  DrawingAttachments: "Drawing Attachments",
  PreservationWorkList: "PWL (Preservation Work List)",
  PreservationDetail: "Preservation Detail",
  PreservationInterval: "Preservation Interval",
  Thereareitemsthathavenotbeenraisedyet: "There are {count} items that have not been raised yet. Only raised items can be deleted.",
  Areyousureyouwanttodeleteselecteditems: "Are you sure you want to delete {count} selected items?",
  Not: "Not",
  Documentcannotbegeneratedasthereisnotemplate: "Document cannot be generated as there is no template",
  Overdue: "Overdue",
  MCC_COMPLETED: "MCC COMPLETED",
  MCC_PENDING: "MCC PENDING",
  MCC_OVERDUE: "MCC OVERDUE",
  CCC_COMPLETED: "CCC COMPLETED",
  CCC_PENDING: "CCC PENDING",
  CCC_OVERDUE: "CCC OVERDUE",
  No: "No",
  AddAuthorisedPersonProfession: "Add Authorised Person Profession",
  CCCAttachments: "CCC Attachments",
  Fulls: "Full",
  Documentation: "Documentation",
  Dossier: "Dossier",
  AddAuthorisedPersonSubcontractorName: "Add Authorised Person Subcontractor Name",
  TaggedItemsDescription: "Tagged Items Description",
  Doyouneedtosavethecurrentstateandaddapunch: "Do you need to save the current state and add a punch?",
  TagPWLTaggedItem: "Tag PWL Tagged Item",
  TaggedItemLocation: "Tagged Item Location",
  TagPWLFrequency: "	Tag PWL Frequency",
  HandoverCertificate: "Handover",
  CloseItems: "Close Items",
  SignOffDate: "Sign Off Date",
  TypeinaDocumentCode: "Type in a Document Code",
  RecentCodes: "Recent Codes",
  Code: "Code",
  DocumentName: "Document Name",
  Uploadfiles: "Upload files",
  SelectEntityType: "Select Entity Type",
  Searchcriteriacleared: "Search criteria cleared",
  Emailsentsuccessfullyto: "Email sent successfully to",
  Usercreatedsuccessfully: "User created successfully, but email sending failed",
  Pleaseselectaprojectfirst: "Please select a project first",
  days: "days",
  TagPWLAttachments: "Tag PWL Attachments",
  TaggedItemsCount: "Tagged Items Count",
  Ongoing: "On going",
  FilterConfiguration: "Filter Configuration",
  SelectFilterConditions: "Filter Conditions",
  PleaseSelectReportFirst: "Please Select Report First",
  ScheduledReportHistoryList: "Scheduled Report History List",
  GenerationTime: "Generation Time",
  FileSize: "File Size",
  Success: "Success",
  Failed: "Failed",
  NoFilterConfigured: "No Filter Configured",
  RelatedTagPWLs: "Related Tag PWLs",
  SearchFor: "Search For",
  NoEmailConfigured: "Email not configured, unable to send notification",
  Emailsendingfailed: "Email sending failed",
  NoRecipientEmail: "Assigned user has no email",
  WorkPageAttachments: "Work Packs Attachments",
  JobCardAttachments: "Job Card Attachments",
  RoundApprovals: "Round Approvals",
  WorkPackTypeDocument: "Work Pack Type Document",
  UploadJSONDocument: "Upload JSON Document",
  WorkPackTypeCoverSheet: "Work Pack Type Cover Sheet",
  CreateCoverSheet: "Create Cover Sheet",
  Noss: "No",
  NoData: "No Data",
  SignaturePreview: "Signature Preview",
  DownloadAPP: "Download APP",
  ScantoDownload: "Download",
  Attention: "Note: Scan with WeChat, then paste in browser to download.",
}
